import React, { useState, useMemo, useEffect, useRef } from "react";
import {
    Button,
    Col,
    Row,
    Table,
    Input
} from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import {
    getData as onGetDataTable,
    setPage as onSetPage,
    clearData as onClearDataTable
} from "../../store/actions";
import PulseLoader from "react-spinners/PulseLoader";

const DataTable = ({ columns = [], url, trigger }) => {
    const dispatch = useDispatch();

    const { data, loading, totalData, totalPage, page, pageSize, filter, t } = useSelector(state => ({
        data: state.DataTable.data,
        loading: state.DataTable.loading,
        totalData: state.DataTable.totalData,
        totalPage: state.DataTable.totalPage,
        page: state.DataTable.page,
        pageSize: state.DataTable.length,
        filter: state.DataTable.filter,
        t: trigger
    }));

    useEffect(() => {
        onGetData()
    }, [page, t])

    const onGetData = () => {
        dispatch(onGetDataTable(url, page, pageSize, filter))
    }

    const onChangeInSelect = (e) => {
        dispatch(onGetDataTable(url, page, Number(e.target.value), filter))
    }

    const onChangeInInput = (e) => {
        const page = e.target.value ? Number(e.target.value) : 1;
        gotoPage(page)
    }

    const canPreviousPage = () => {
        return page > 1
    }

    const previousPage = () => {
        const curPage = page;
        dispatch(onSetPage(curPage - 1, pageSize))
    }

    const nextPage = () => {
        const curPage = page;
        dispatch(onSetPage(curPage + 1, pageSize))
    }

    const canNextPage = () => {
        return page < totalPage
    }

    const gotoPage = (p) => {
        dispatch(onSetPage(p, pageSize))
        // onGetData()
    }

    useEffect(() => {
        if (filter != null && filter != undefined && filter.companyId != null && filter.companyId != undefined) {
            onGetData()
        }
        else{
            dispatch(onClearDataTable())
        }
    }, [])

    return <>
        <div className="table-responsive react-table mt-4">
            <Table bordered hover>
                <thead className="table-light table-nowrap">
                    <tr>
                        {
                            columns.map(col => {
                                return <th key={col.key} className={col.headerClass ?? ""}>
                                    {col.name}
                                </th>
                            })
                        }
                    </tr>
                </thead>
                <tbody>
                    {
                        loading &&
                        <tr>
                            <td colSpan={columns.length} className="text-center">
                                <center><PulseLoader loading={true} color={'#FFF'} /></center>
                            </td>
                        </tr>
                    }
                    {
                        !loading && data && filter && filter.companyId &&
                        data.map((row, rowIdx) => {
                            return <tr key={'row' + rowIdx}>
                                {
                                    columns.map((c, i) => {
                                        return <td key={'cell' + rowIdx + i} className={c.contentClass ?? ""}>
                                            {c.render ? c.render(row) : row[c.key]}
                                        </td>
                                    })
                                }
                            </tr>
                        })
                    }
                    {
                        (!data || (data && data.length == 0)) && !loading &&
                        <tr>
                            <td colSpan={columns.length} className="text-center">No Data Available</td>
                        </tr>
                    }
                </tbody>
            </Table>

        </div>
        <Row className="justify-content-center align-items-center">
            <Col md={1}>
                <select
                    className="form-select"
                    value={pageSize}
                    onChange={onChangeInSelect}
                >
                    {[10, 20, 50, 100].map(pageSize => (
                        <option key={pageSize} value={pageSize}>
                            Show {pageSize}
                        </option>
                    ))}
                </select>
            </Col>
            <Col>
                <div>Showing {
                    page == 1 && data && data.length > 0 ? 1 : (page - 1) * pageSize
                }-{totalData < (page * pageSize) ? totalData : (page * pageSize)} of {totalData} entries.</div>
            </Col>
            <Col className="col-md-auto ms-auto">
                <div className="d-flex gap-1">
                    <Button
                        color="primary"
                        onClick={() => gotoPage(1)}
                        disabled={!canPreviousPage()}
                    >
                        {"<<"}
                    </Button>
                    <Button
                        color="primary"
                        onClick={previousPage}
                        disabled={!canPreviousPage()}
                    >
                        {"<"}
                    </Button>
                </div>
            </Col>
            <Col className="col-md-auto d-none d-md-block">
                Page{" "}
                <strong>
                    {page} of {totalPage}
                </strong>
            </Col>
            <Col className="col-md-auto">
                <Input
                    type="number"
                    min={1}
                    style={{ width: 70 }}
                    max={totalPage}
                    value={page}
                    onChange={onChangeInInput}
                />
            </Col>
            <Col className="col-md-auto">
                <div className="d-flex gap-1">
                    <Button color="primary" onClick={nextPage} disabled={!canNextPage()}>
                        {">"}
                    </Button>
                    <Button
                        color="primary"
                        onClick={() => gotoPage(totalPage)}
                        disabled={!canNextPage()}
                    >
                        {">>"}
                    </Button>
                </div>
            </Col>
        </Row>
    </>
}

export default DataTable;